import { BleTagClient } from 'api/api';
import { AsyncOperationBuilder } from 'utilities/api-helper';
import { bleTagClient } from '../api-clients';
import { GetBleConnectionHistoryAction } from './actions';

export async function getBleConnectionHistory(serialNumber: string, startDate: Date, endDate: Date) {
	return AsyncOperationBuilder(
		GetBleConnectionHistoryAction,
		apiClient =>
			(apiClient as BleTagClient).getConnectionHistoryBySerialNumber(serialNumber, startDate, endDate),
		{ serialNumber, startDate, endDate },
		bleTagClient
	);
}
